import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';

/*
  What the current plan allows, read once from /api/billing/status.

  The screens use this to show a lock BEFORE the user clicks, instead of
  letting them fill in a form and meet a 402 at the end. When billing is
  dormant the backend reports the top edition, so nothing is locked and the
  product behaves exactly as it did before billing existed.
*/

let cache = null;
let inflight = null;

export function invalidatePlanAccess() {
  cache = null;
  inflight = null;
}

async function load() {
  if (cache) return cache;
  if (!inflight) {
    inflight = axios
      .get(`${API}/billing/status`)
      .then((r) => {
        cache = r.data || {};
        return cache;
      })
      .catch(() => {
        // Never let a billing hiccup hide the product: fall back to allowing
        // everything and let the server be the authority.
        cache = { __unavailable: true };
        return cache;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export default function usePlanAccess() {
  const [data, setData] = useState(cache);

  useEffect(() => {
    let cancelled = false;
    load().then((d) => {
      if (!cancelled) setData(d);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const plan = data?.plan || {};
  const features = plan.features || {};
  const limits = plan.limits || {};
  const unavailable = !data || data.__unavailable;

  return {
    loading: !data,
    planKey: data?.state?.plan || null,
    planLabel: plan.label || null,
    limits,
    features,
    // Unknown plan shape means do not block anything client side.
    allows: (feature) => (unavailable || !plan.features ? true : Boolean(features[feature])),
    limit: (key) => (unavailable ? null : limits[key]),
  };
}
